/* eslint-disable import/no-default-export */
import React from 'react';

import Badge from '../Badge';

const ListFieldBadge = ({ field, item }) => {
  if (!item || !item.idValue || !field || !field.options) {
    return null;
  }

  const option = field.options.find((opt) => opt.id === item.idValue);
  if (!option || !option.value || !option.value.text) {
    return null;
  }

  let bgColor = 'transparent';
  let fontColor = 'N400';
  if (option.color && option.color !== 'none') {
    bgColor = `${option.color}-500`;
    fontColor = 'N0';
  }

  return (
    <Badge bgColor={bgColor} fontColor={fontColor}>
      <span>{`${field.name}: ${option.value.text}`}</span>
    </Badge>
  );
};

export default ListFieldBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/ListFieldBadge.js